export default __webpack_public_path__ + "static/media/menu3_hl.2fbe6e74.png";